export default function SubTabs({ show, selectedTab, selectTab, buttons }) {
  if(!show) return null;
  return (
    <div
      className="button_container"
      style={{
        width: "100% !important",
        justifyContent: "start",
        gap:"20px",
        marginTop:"0 !important"
      }}
    >
      {buttons.filter(button => button.show).map((button, index) => {
        return (
          <button
            key={index}
            type="button"
            style={{
              opacity:selectedTab === button.id ? 0.6:1,
              fontFamily:"Poppins"
            }}
            className={selectedTab === button.id ? "button selected_button opacity-60" : "button"}
            onClick={() => selectTab(button.id)}
            id="button_70"
          >
            {button.name}
          </button>
        );
      })}
    </div>
  );
}
